/* tslint:disable */
/* eslint-disable */
/**
 * RaidSIMP OpenAPI Spec
 * Manage your raid teams, enhanced with data from the Blizzard API.
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CollaboratorDto
 */
export interface CollaboratorDto {
    /**
     * 
     * @type {string}
     * @memberof CollaboratorDto
     */
    role: CollaboratorDtoRoleEnum;
}

/**
* @export
* @enum {string}
*/
export enum CollaboratorDtoRoleEnum {
    Editor = 'editor',
    Viewer = 'viewer'
}

export function CollaboratorDtoFromJSON(json: any): CollaboratorDto {
    return CollaboratorDtoFromJSONTyped(json, false);
}

export function CollaboratorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CollaboratorDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'role': json['role'],
    };
}

export function CollaboratorDtoToJSON(value?: CollaboratorDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'role': value.role,
    };
}


